
const facilityEnrollmentStatuses = Object.freeze({
    Active: 1,
    OnHold: 2,
    Closing: 3
});

export default facilityEnrollmentStatuses;